import React from 'react';

interface SimplifyPathIconProps {
  className?: string;
  size?: number;
}

/**
 * Custom SVG Icon representing 'Simplify Path' (Vector curve with reduced anchor points)
 */
export const SimplifyPathIcon: React.FC<SimplifyPathIconProps> = ({ 
  className = 'w-4 h-4', 
  size 
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Smooth Vector Curve */}
      <path d="M4 18 C 7 8, 17 16, 20 6" stroke="currentColor" strokeWidth="2" />
      
      {/* Key Anchor Nodes (Square handles) */}
      <rect x="2.5" y="16.5" width="3" height="3" fill="currentColor" stroke="none" rx="0.5" />
      <rect x="18.5" y="4.5" width="3" height="3" fill="currentColor" stroke="none" rx="0.5" />
      
      {/* Midpoint Anchor Node with Reduction Indicators */}
      <circle cx="11.5" cy="12" r="1.5" fill="currentColor" stroke="none" />
      
      {/* Sparkle / Optimization Accent rays */}
      <path d="M16 9 L17 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18 10 L20 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 13 L5.5 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
